










import { Component, Vue } from "vue-property-decorator";
import iconLaba from "@/assets/img/laba.svg";
import { isEnableEasyMailEditor } from "@/utils/experiment";

const EASY_MAIL_NEED_NOTICE = "easy-mail-needNotice";

@Component
export default class EasyMailRemind extends Vue {
  show = false;
  iconLaba = iconLaba;

  created() {
    const easyMailNeedNotice = localStorage.getItem(EASY_MAIL_NEED_NOTICE);
    // 如果未设置或设置为true，则显示
    if (isEnableEasyMailEditor() && (easyMailNeedNotice === null || easyMailNeedNotice === "true")) {
      // 设置一个css变量，其他样式进行避免
      document.documentElement.style.setProperty('--easy-mail-remind-height', '64px');
      this.show = true;
      localStorage.setItem(EASY_MAIL_NEED_NOTICE, "true");
    } else {
      document.documentElement.style.setProperty('--easy-mail-remind-height', '0px');
      this.show = false;
    }
  }

  close() {
    this.show = false;
    document.documentElement.style.setProperty('--easy-mail-remind-height', '0px');
    // 不再提醒
    localStorage.setItem(EASY_MAIL_NEED_NOTICE, "false");
    this.$router.go(0);
  }
}
